import * as React from "react";
import { UitkSheet } from "uitk-react-sheet";
import { UitkToolbar, UitkToolbarProps } from "uitk-react-toolbar";
import { LinksDialogContext } from "components/flexComponents/Links/GridView/LinkDialogContext";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import Links from "components/flexComponents/Links/Links";
import { BlossomComponent } from "src/components/flexFramework/domain/BlossomComponent";
import { TemplateComponent } from "experience-template-renderer-react";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkScrollable } from "uitk-react-scrollable";
import { RegionChildren } from "src/utils/RegionUtils";
import { LinksTemplateComponent } from "../typings";

interface LinkDialogProps {
  id: string;
  onDismiss: () => void;
  blossomComponent: BlossomComponent;
  templateComponents: LinksTemplateComponent[];
  isOpen: boolean;
}

export const LinkDialog = (props: LinkDialogProps) => {
  const { id, onDismiss, blossomComponent, templateComponents, isOpen } = props;
  const linksDialogContext = LinksDialogContext;

  const keyHelper = new ItemKeyHelper(`LinkDialog-${id}`);

  const toolBarAttributes: UitkToolbarProps = {
    toolbarTitle: linksDialogContext.dialogHeading,
    navigationContent: {
      navIconLabel: "Close",
      onClick: onDismiss,
    },
  };

  const triggerRef = React.createRef<HTMLElement>();

  const linkItems = linksDialogContext.modules.map((module, index) => {
    if (module.type === "link-juice" && templateComponents && blossomComponent) {
      const linksJuiceModule = templateComponents.filter((groupItem: TemplateComponent) => {
        /* istanbul ignore next */
        if (groupItem.children) {
          const [element] = groupItem.children;
          return element.metadata?.id === module.metadata.id;
        }
        return false;
      });
      // Asserted none null children in the filter
      return (
        <RegionChildren
          key={`link-dialog-item-${index}`}
          templateComponent={linksJuiceModule[0]}
          blossomComponent={blossomComponent}
        />
      );
    }
    return <Links key={keyHelper.next()} templateComponent={module} insideTabGroupParam />;
  });

  return (
    <UitkSheet type="centered" centeredSheetSize="small" triggerRef={triggerRef} isVisible={isOpen}>
      <div>
        <UitkToolbar {...toolBarAttributes} />
      </div>
      <UitkSpacing padding={{ blockstart: "one" }} margin="one">
        <UitkScrollable direction="vertical">
          <div className="LinkDialog">{linkItems}</div>
        </UitkScrollable>
      </UitkSpacing>
    </UitkSheet>
  );
};
